import './App.css';
import { useEffect, useState } from 'react';
import routes from './routes';
import { useNavigate, useParams, useRoutes } from 'react-router-dom';
import Menu from './components/Menu/Menu';
import { useLocation } from 'react-router-dom'
import Loader from './components/Loader/Loader';
import { useOrders } from './pages/DefaultPage/connect/Orders';
import ServerErr from './components/Errors/500';
import SplashView from './pages/Splash/Splash';
import DesktopHeader from './components/DesktopHeader/DesktopHeader';
import { useUserInfo } from './pages/Profile/connect/User';
import MobileLayout from './Layouts/MobileLayout';
import DesktopLayout from './Layouts/DesktopLayout';
function App() {
  const [showSplash, setShowSplash] = useState(false);
  const { getUserInfo, getIsBusinessUser, getUserInfoWithMobile } = useUserInfo(
    (state) => state.actions
  );
  const userInfoWithMobile = useUserInfo((state) => state.userInfoWithMobile);


  const getUserInfoWithMobileHandler = async () => {
    await getUserInfoWithMobile(
      localStorage.getItem("phoneNumber")
        ? localStorage.getItem("phoneNumber")
        : localStorage.getItem("mergedValue")
    );
  };


  const [checkWidth, setCheckWidth] = useState(window.innerWidth)
  const reportWindowSize = () => {
    setCheckWidth(window.innerWidth)
  }
  window.onresize = reportWindowSize;
  const location = useLocation();
  useEffect(() => {
    // getUserInfoWithMobileHandler();

    // let darkMode = localStorage.getItem("veeu-dark-mode");
    // if (darkMode === "true") {
    //   document.getElementById("root").classList.add("dark");
    //   document.documentElement.classList.add("dark");
    // } else {
    //   document.getElementById("root").classList.remove("dark");
    //   document.documentElement.classList.remove("dark");
    // }

    // setting the dark mode as default
    const darkMode = localStorage.getItem("veeu-dark-mode");
    if (darkMode === null) {
      // First time visit: set default to dark mode
      localStorage.setItem("veeu-dark-mode", "true");
      document.documentElement.classList.add("dark");
    } else {
      // Apply class based on stored value
      if (darkMode === "true") {
        document.documentElement.classList.add("dark");
      } else {
        document.documentElement.classList.remove("dark");
      }
    }

    if (location.pathname.startsWith("/chatPage")) {
      document.documentElement.style.overflow = 'hidden';
    } else {
      document.documentElement.style.overflow = 'auto'; // یا 'visible' بسته به نیاز شما
    }
    // if (location.pathname == "/") {
    //   setShowSplash(true)
    //   setTimeout(() => {
    //     setShowSplash(false)
    //   }, 3500);
    // }

    // if (userInfoWithMobile.length == 0) {
    //   // localStorage.clear()
    //   console.log("userInfoWithMobile");
    //   console.log(userInfoWithMobile);
    // }
  }, []);



  return (
    <>
      {checkWidth > 1022 ?
        <DesktopLayout />
        :
        <MobileLayout />
      }
    </>
  );
}

export default App;
